import PostsAdapter from './base';

export default class PageSet extends PostsAdapter {
  modelNamePlural = 'pageSets';
}
